'use strict'

import {createScapiFetch} from './utils'

class AlertMgr {
    constructor(config) {
        this.config = config
        this.fetch = createScapiFetch(config)
    }

    /**
     * Sends an alert using the provided alert object and access token.
     *
     * @async
     * @param {Object} alertObj - The alert object containing alert details.
     * @param {boolean} alertObj.logging - Indicates if logging is enabled for the alert.
     * @param {string} alertObj.alertType - The type of the alert.
     * @param {Object} alertObj.context - The context of the alert.
     * @param {string} alertObj.context.message - The message of the alert. You can use `error.message` from catch. Required.
     * @param {string} alertObj.context.category - The category of the alert.
     * @param {string} alertObj.context.order - The order associated with the alert.
     * @param {string} alertObj.context.page - The page associated with the alert.
     * @param {string} alertObj.context.job - The job associated with the alert.
     * @param {string} alertObj.context.asset - The asset associated with the alert.
     * @param {string} alertObj.context.identifier - The identifier for the alert.
     * @param {string} alertObj.context.fileName - The file name where the alert originated.
     * @param {number} alertObj.context.lineNumber - The line number where the alert originated.
     * @param {object} alertObj.context.initialRequest - The initial request data associated with the alert. Inserted into the alert email, so the data isn't lost.
     * @param {string} accessToken - The access token for authentication.
     * @returns {Promise<Object>} The response from the alert manager or an empty object if no response.
     */
    async sendAlert(alertObj, accessToken) {
        let urlParam = {
            querystring: {}
        }

        const body = {
            context: alertObj.context,
            alertType: alertObj.alertType,
            logging: alertObj.logging
        }

        let endpoint = 'send'
        let method = 'POST'
        let args = [urlParam]
        let methodName = 'sendAlert'
        let requestParams = {
            body: body,
            apiPath: 'alert',
            accessToken: accessToken,
            isCached: false,
            siteID: alertObj.siteId
        }
        let apiVersion = 'v1'

        let alertMgrResponse = await this.fetch(
            endpoint,
            method,
            args,
            methodName,
            requestParams,
            apiVersion
        )

        return alertMgrResponse || {}
    }
}

export default AlertMgr
